import { render } from "./Order-detail.vue?vue&type=template&id=180bef7d&scoped=true"
import script from "./Order-detail.vue?vue&type=script&lang=js"
export * from "./Order-detail.vue?vue&type=script&lang=js"

import "./Order-detail.vue?vue&type=style&index=0&id=180bef7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180bef7d"]])

export default __exports__